import * as Api from '@ViewModels';

// Note: Controller does not support impersonation
export const getSystemJob = (userSession: Api.UserSessionContext, jobId: string) => {
	return userSession.webServiceHelper.callAsync<Api.IBlogGenerationSystemJob>(
		Api.ImpersonationBroker.composeApiUrl({ urlPath: `SystemJob/${jobId}` }),
		'GET'
	);
};

const POLL_INTERVAL_MS = 3000;
// 120 × 3s = 6 min cap — prevents unbounded polling if a job stalls.
const MAX_POLLS = 120;

/**
 * Polls `SystemJob/:id` until the job reports `percentComplete === 100`, aborts via the
 * cancellation signal, or exceeds `MAX_POLLS` iterations (whichever happens first).
 * Returns the completed job, or `null` if cancelled. Throws on generation failure or timeout.
 */
export const pollSystemJob = async (
	userSession: Api.UserSessionContext,
	jobId: string,
	cancelToken?: AbortSignal
): Promise<Api.IBlogGenerationSystemJob | null> => {
	for (let attempt = 0; attempt < MAX_POLLS; attempt++) {
		if (cancelToken?.aborted) return null;

		const systemJob = await getSystemJob(userSession, jobId);

		if (cancelToken?.aborted) return null;

		if (systemJob?.percentComplete === 100) {
			if (systemJob.generatedContent) {
				return systemJob;
			}
			throw Api.asApiError('Blog generation failed');
		}

		await new Promise(resolve => setTimeout(resolve, POLL_INTERVAL_MS));
	}

	throw Api.asApiError('Blog generation timed out');
};
